import { getVisibleSpartanProductNavClearance } from '@/app/lcv/components/sections/spartan/products/customize/configurator/grade-selection/nav-clearance';
import { SPARTAN_PRODUCT_CUSTOMIZE_TRACKING } from '@/app/lcv/components/sections/spartan/products/customize/tracking';
import { getSpartanProductLenis } from '@/app/lcv/components/sections/spartan/products/shared/product-scroll/store';

const PREVIEW_ALREADY_IN_VIEW_PX = 8;

const runAfterScrollCommit = (callback?: () => void) => {
  if (!callback) return;

  requestAnimationFrame(() => {
    requestAnimationFrame(callback);
  });
};

const snapPreviewToClearance = (preview: HTMLElement, clearance: number) => {
  const lenis = getSpartanProductLenis();
  if (lenis) {
    lenis.scrollTo(preview, {
      offset: -clearance,
      force: true,
      immediate: true,
    });
    return;
  }

  const top = Math.max(
    0,
    window.scrollY + preview.getBoundingClientRect().top - clearance
  );
  window.scrollTo({ top, behavior: 'instant' });
};

export interface ScrollSpartanCustomizePreviewIntoViewOptions {
  onSettled?: () => void;
}

/** Scroll the customize preview to sit just below the currently visible nav. */
export const scrollSpartanCustomizePreviewIntoView = ({
  onSettled,
}: ScrollSpartanCustomizePreviewIntoViewOptions = {}) => {
  const preview = document.querySelector<HTMLElement>(
    `[data-test="${SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.preview}"]`
  );
  if (!preview) {
    onSettled?.();
    return;
  }

  const clearance = getVisibleSpartanProductNavClearance();
  const isAligned =
    Math.abs(preview.getBoundingClientRect().top - clearance) <=
    PREVIEW_ALREADY_IN_VIEW_PX;

  if (!isAligned) {
    snapPreviewToClearance(preview, clearance);
    runAfterScrollCommit(onSettled);
    return;
  }

  onSettled?.();
};
